import { Anchor, Breadcrumbs, Group, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

interface BillingBreadcrumbProps {
  crumbs?: Crumb[];
  backTo?: string;
  backLabel?: string;
}

export function BillingBreadcrumb({ crumbs = [], backTo, backLabel = 'Back' }: BillingBreadcrumbProps): JSX.Element {
  return (
    <Group gap="md" align="center">
      {backTo && (
        <Anchor component={Link} to={backTo} size="sm" fw={600}>
          <Group gap={4} wrap="nowrap">
            <IconArrowLeft size={16} />
            {backLabel}
          </Group>
        </Anchor>
      )}
      {crumbs.length > 0 && (
        <Breadcrumbs separator="→">
          {crumbs.map((crumb) =>
            crumb.to ? (
              <Anchor key={crumb.label} component={Link} to={crumb.to} size="sm">
                {crumb.label}
              </Anchor>
            ) : (
              <Text key={crumb.label} size="sm" c="dimmed">
                {crumb.label}
              </Text>
            ),
          )}
        </Breadcrumbs>
      )}
    </Group>
  );
}
